import React from 'react'
import NKModal from './NKModal.jsx'


const OkDialog = React.createClass({
    propTypes: {
        melding: React.PropTypes.string.isRequired        
    },
    getInitialState: function () {
        return { isOpen: true };
    },
    closeModal: function () {
        this.props.isOpen = false; 
    },
    render() {

        return (
            <NKModal size='medium' isOpen={this.props.isOpen}   >
                <div className="modal-content">
                    <div className="modal-header">
                        <button className="close" onClick={this.props.onClose} type="button">
                            <span>x</span>
                            <span className="sr-only">Lukk</span>
                        </button>
                        <h4 className="modal-title">{this.props.tittel}</h4>
                    </div>
                    <div className="modal-body">
                        {this.props.melding}
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-primary" onClick={this.props.onOk}>OK</button>
                    </div>
                </div>
            </NKModal>
        );
    }
});

export default  OkDialog;


// WEBPACK FOOTER //
// ./src/felles/Dialogs/OkDialog.jsx